import { send } from "./auth";

/* git 호스트 연결(`crates/api/src/git_connections.rs` · `git_app.rs`)과 MCP 링크 승인(`mcp_oauth.rs`).
   토큰 · 시크릿은 어느 답에도 안 실린다 — 화면이 아는 것은 「걸려 있나」(`tokenSet`)와 승인한 계정뿐이다. */

export type GitConn = {
  id: string;
  provider: string;
  label: string;
  baseUrl: string;
  clientId: string;
  tokenSet: boolean;
  refreshSet: boolean;
  expiresAt: string | null;
  account: string | null;
  connectedBy: string | null;
  connectedAt: string | null;
  lastError: string | null;
  createdAt: string;
  repoCount: number;
};

export type GitConnList = { redirectUri: string; providers: string[]; connections: GitConn[] };

export type GitSetup = {
  provider: string;
  /** 앱까지 링크로 만드는 호스트(GitHub)면 그 링크. 있으면 손 등록 칸을 접는다. */
  appLinkUrl: string | null;
  appSetupUrl: string;
  redirectUri: string;
  scope: string;
};

/** 표의 상태 셋 — 모양+글자로 간다(색만으로 안 가른다). */
export type ConnState = "ok" | "broken" | "pending";
export function connState(c: GitConn): ConnState {
  if (c.lastError) return "broken";
  return c.tokenSet ? "ok" : "pending";
}

export type OAuthRequest = {
  id: string;
  clientName: string;
  redirectUri: string;
  expiresAt: string;
  approved: boolean;
  suggestedName: string;
};

/** 돌려보낼 곳이 이 컴퓨터(루프백)인가 — 아니면 화면이 한 번 더 확인시킨다. */
export function isLoopback(uri: string): boolean {
  try {
    const h = new URL(uri).hostname;
    return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h === "::1";
  } catch {
    return false;
  }
}

export const gitConnApi = {
  list: () => send<GitConnList>("GET", "/admin/git-connections"),
  setup: (provider: string, baseUrl: string) =>
    send<GitSetup>(
      "GET",
      `/admin/git-connections/setup?provider=${encodeURIComponent(provider)}&baseUrl=${encodeURIComponent(baseUrl)}`,
    ),
  create: (b: { provider: string; label: string; baseUrl: string; clientId: string; clientSecret: string }) =>
    send<GitConn>("POST", "/admin/git-connections", b),
  /** 승인 링크 — 브라우저를 그 주소로 보낸다. 10분 뒤 버려진다. */
  authorize: (id: string) => send<{ url: string }>("POST", `/admin/git-connections/${encodeURIComponent(id)}/authorize`),
  remove: (id: string) => send<null>("DELETE", `/admin/git-connections/${encodeURIComponent(id)}`),
};

export const oauthApi = {
  request: (id: string) => send<OAuthRequest>("GET", `/admin/oauth/requests/${encodeURIComponent(id)}`),
  approve: (id: string, name: string) =>
    send<{ redirect: string; name: string }>("POST", `/admin/oauth/requests/${encodeURIComponent(id)}/approve`, { name }),
  deny: (id: string) => send<{ redirect: string }>("POST", `/admin/oauth/requests/${encodeURIComponent(id)}/deny`),
};
